import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  AUTH_STATUS_APPROVE,
} from "constants/FormatDataContanst";
import { TYPE_ACTION_WORKFLOW } from "constants/IssueInvoiceConstant";

export const KyHieuMauHoaDonList = [
  { key: "VAT", value: "1", label: "1 - Hóa đơn GTGT", prefix: "T" },
  { key: "SALE", value: "2", label: "2 - Hóa đơn bán hàng", prefix: "T" },
];

export const initOptionDateLocale = {
  altInput: true,
  altFormat: "d/m/Y H:i:S",
  dateFormat: "d/m/Y H:i:S",
  allowInput: true,
  // shorthandCurrentMonth:true,
  locale: {
    firstDayOfWeek: 1,
  },
};

export const invoiceTypeMode = {
  HAVE_CODE: "1",
  NONE_CODE: "0",
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da} 00:00:00`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const tableFormateDate = (data, isSecond = false) => {
  if (new Date(Number(data)).toString() !== "Invalid Date") {
    if (isSecond) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "numeric",
      }).format(data * 1000);
    } else {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(data * 1000);
    }
  }
  return "";
};

export const MODE_FORM = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
  CREATE_REPORT: "create_report",
};

export const getDateStartEndByRangeMonth = (monthStart, monthEnd, year) => {
  const dateStart = `01/${monthStart}/${year}`;
  const lastDateEnd = new Date(year, Number(monthEnd) + 1, 0).getDate();
  const dateEnd = `${lastDateEnd}/${monthEnd}/${year}`;
  return { dateStart, dateEnd };
};

export const COMMON_CONDITION_VISIBLE = {
  SEND_APPROVE: {
    approve_status: [APPROVE_STATUS_M],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  REJECT: {
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  APPROVE: {
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  RELEASE: {
    approve_status: [APPROVE_STATUS_A],
    auth_status: [AUTH_STATUS_APPROVE],
  },
};

export const getTypeWorkflowMessage = typeMode => {
  let mess = "";
  switch (typeMode) {
    case TYPE_ACTION_WORKFLOW.SUBMIT:
      mess = "Gửi duyệt đợt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.APPROVE:
      mess = "Duyệt đợt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.REJECT:
      mess = "Từ chối duyệt đợt CTKT";
      break;
    default:
      break;
  }
  return mess;
};
